import { useCallback } from 'react';
import { Row, Col } from 'reactstrap';
import { useFormState } from 'utils/hooks';
import { useDispatch } from 'react-redux';
import useRouter from 'use-react-router';

import { FormState } from 'common/entities/form/FormTypes';
import Select from 'common/components/form/inputs/Select';
import { DrawerState } from 'common/entities/drawer/DrawerTypes';

import { getLinkedPurchasingStores } from 'store/purchasing-stores/actions';

import GroupField from '../components/GroupField';

const LinkSection = ({ formState, drawer }) => {
  const { fields, selectField } = useFormState(formState);
  const dispatch = useDispatch();
  const { match } = useRouter();
  const { params } = match;
  const { organizationId } = params;

  const onFetchOceanItems = useCallback(
    async search => {
      if (!organizationId || !fields?.store_group?.value?.id) return;

      const filters = [
        { name: 'store_group_id', operation: 'oneOf', value: [fields?.store_group?.value?.id] }
      ];

      try {
        const res = await dispatch(
          getLinkedPurchasingStores({
            filters,
            search
          })
        );

        return res?.payload?.data;
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch, organizationId, fields?.store_group?.value?.id]
  );

  return (
    <Row>
      <Col xs={12} className="mb-2">
        {drawer?.isOpen ? (
          <GroupField
            key={organizationId}
            label="Item Group"
            placeholder="Select group to filter items"
            onChange={e => {
              selectField('store_group')(e);
              selectField('equivalent_item')(null);
            }}
            storeGroup={fields?.store_group}
          />
        ) : null}
      </Col>

      <Col xs={12} className="mb-1">
        <Select
          isAsync
          invisible={false}
          defaultOptions={onFetchOceanItems}
          loadOptions={onFetchOceanItems}
          onChange={selectField('equivalent_item')}
          getOptionValue={option => option.id}
          disabled={!fields?.store_group?.value?.id}
          getOptionLabel={option => option.description}
          defaultOptionsTriggerChange={fields?.store_group?.value?.id || organizationId}
          placeholder="Select item"
          label="Equivalent Item"
          {...fields.equivalent_item}
        />
      </Col>
    </Row>
  );
};

export default LinkSection;

LinkSection.propTypes = {
  formState: FormState,
  drawer: DrawerState.isRequired
};
